import { render, staticRenderFns } from "./DetailPermohonanPenambahanKbli.vue?vue&type=template&id=233e26c4&"
import script from "./DetailPermohonanPenambahanKbli.vue?vue&type=script&lang=js&"
export * from "./DetailPermohonanPenambahanKbli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports